import {
  PDFLabelSections,
  type PDFLabelSectionEnum,
} from '@webapp/modules/vendor/entities/enums/PDFLabelSectionEnum' // eslint-disable-line import/no-internal-modules

/**
 * Domain-side port of the Angular `LABEL_SECTION_MAP` constant: which editor
 * section each PDF label field belongs to, in display order. Keys are the
 * entity-side field keys (camelCase for fields the PDF label set mapper
 * renames; raw pass-through keys — e.g. 'blanket', 'expiry_date',
 * 'New Request Field' — stay as the API sends them).
 */
export const LABEL_SECTION_MAP: Record<PDFLabelSectionEnum, readonly string[]> =
  {
    [PDFLabelSections.PO_FIELDS]: [
      'purchaseOrder',
      'blanket',
      'prefVendor',
      'shipTo',
      'poNumber',
      'date',
      'paymentTerms',
      'shippingTerms',
      'shippingMethod',
      'promiseDate',
      'expiry_date',
      'comment',
      'creditcard',
    ],
    [PDFLabelSections.PO_COSTS]: [
      'subtotal',
      'discount',
      'freight',
      'other',
      'tax',
      'total',
    ],
    [PDFLabelSections.ITEM_FIELDS]: [
      'sku',
      'unit',
      'itemDescription',
      'price',
      'totalPrice',
      'New Request Field',
      'poNote',
      'quantity',
    ],
  }
